__turbopack_context__.v({
  "className": "caveat_4270369b-module__-RgqEW__className",
  "variable": "caveat_4270369b-module__-RgqEW__variable",
});
